module.exports = __webpack_public_path__ + "static/hero-e5207b809d4a7b283193dceca6b936ae.jpg";